(() => {
  if (window.sootangStickyPreorderLoaded) return;
  window.sootangStickyPreorderLoaded = true;

  const selector = '[data-st-mobile-preorder-bar]';
  const roots = () => document.querySelectorAll(selector);

  const mountRoots = () => {
    [...roots()].forEach((root) => {
      if (root.parentElement === document.body) return;

      const duplicate = [...document.body.children].find(
        (child) =>
          child.matches?.(selector) &&
          child.dataset.sourceButtonId === root.dataset.sourceButtonId
      );
      duplicate?.remove();
      document.body.appendChild(root);
    });
  };

  const readVariants = (root) => {
    if (root.sootangVariants) return root.sootangVariants;

    try {
      root.sootangVariants = JSON.parse(
        root.querySelector('[data-st-mobile-preorder-variants]')?.textContent || '[]'
      );
    } catch (error) {
      root.sootangVariants = [];
    }

    return root.sootangVariants;
  };

  const syncRoot = (root) => {
    const form = document.getElementById(root.dataset.productFormId);
    const sourceButton = document.getElementById(root.dataset.sourceButtonId);
    const stickyButton = root.querySelector('[data-st-mobile-preorder-submit]');
    const price = root.querySelector('[data-st-mobile-preorder-price]');
    const variantId = form?.querySelector('input[name="id"]')?.value;
    const variants = readVariants(root);
    let variant = variants.find((item) => String(item.id) === String(variantId));

    if (!variant && sourceButton) {
      const selectedOptions = [...sourceButton.closest('product-info')?.querySelectorAll('variant-selects fieldset, variant-selects select') || []]
        .map((optionGroup) =>
          optionGroup.matches('select')
            ? optionGroup.value
            : optionGroup.querySelector('input[type="radio"]:checked')?.value
        )
        .filter(Boolean);

      variant = variants.find(
        (item) =>
          item.options?.length === selectedOptions.length &&
          item.options.every((option, index) => option === selectedOptions[index])
      );
    }

    variant ||= variants[0];

    if (variant?.deposit && price && price.textContent.trim() !== variant.deposit) {
      price.textContent = variant.deposit;
    }

    const disabled = !sourceButton || sourceButton.disabled || !variant || !variant.available || !variant.hasPlan;
    if (stickyButton && stickyButton.disabled !== disabled) stickyButton.disabled = disabled;
  };

  const syncAll = () => {
    mountRoots();
    roots().forEach(syncRoot);
  };
  let syncFrame;
  const scheduleSync = () => {
    window.cancelAnimationFrame(syncFrame);
    syncFrame = window.requestAnimationFrame(syncAll);
  };

  document.addEventListener('click', (event) => {
    const stickyButton = event.target.closest('[data-st-mobile-preorder-submit]');
    if (!stickyButton || stickyButton.disabled) return;

    const root = stickyButton.closest('[data-st-mobile-preorder-bar]');
    const sourceButton = document.getElementById(root?.dataset.sourceButtonId);
    if (sourceButton && !sourceButton.disabled) sourceButton.click();
  });

  document.addEventListener('change', scheduleSync, true);
  document.addEventListener('variant:change', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);

  const observer = new MutationObserver(scheduleSync);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['disabled', 'value'],
    childList: true,
    subtree: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }
})();
